export const formatNumber = (number) => {
    return Math.round((number + Number.EPSILON) * 100) / 100
}

export const formatNumberWithSpaces = (number) => {
    let parts = Number(number).toFixed(2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "\xa0");
    return parts.join(".");
}